export enum UserStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}

export enum MFAType {
  TOTP = "TOTP",
  WEBAUTHN = "WEBAUTHN",
}

export enum EventStatus {
  Completed = "Completed",
  Failed = "Failed",
  In_Progress = "In Progress",
  Aborted = "Aborted",
  Starting = "Starting",
  Paused = "Paused",
  Queued = "Queued",
}

export enum EventType {
  UNKNOWN = -1,
  ERROR = 0,
  INFO = 1,
  WARNING = 2,
}

export enum JobStatus {
  New = "NEW",
  Running = "RUNNING",
  Completed = "COMPLETED",
  Aborted = "ABORTED",
  Paused = "PAUSED",
  Failed = "FAILED",
  Input_Required = "INPUT_REQUIRED",
}

export enum BlockType {
  RECOVER = 0,
  ENVIRONMENT = 1,
  REPORT = 2,
  SCRIPT = 3,
  REBOOT = 4,
  MANUAL = 5,
  REPLICATE = 6,
}

export enum ModalExit {
  COMPLETE = 0,
  CANCELED = 1,
}

export enum ProductType {
  SELECT = "select", //Used for dropdowns and stuff
  ABMR = "ABMR",
  CBMR = "CBMR",
  COBMR = "COBMR",
  NBMR = "NBMR",
  TBMR = "TBMR",
  CLONEMANAGER = "CLONEMANAGER",
  CMLITE = "CMLITE",
  PROTECT_FOR_VMS = "PROTECT_FOR_VMS",
  TSMVE = "TSMVE",
  XBMR = "XBMR",
  ET = "ET",
  RBMR = "RBMR",
  VA = "VA",
  PBMR = "PBMR",
}

export enum PostRecoveryOption {
  REBOOT = "REBOOT",
  LEAVE = "LEAVE",
  DELETE = "DELETE",
}

export enum HypervisorType {
  AMAZON = "AMAZON",
  AZURE = "AZURE",
  HYPERV = "HYPERV",
  NUTANIX = "NUTANIX",
  ORACLE = "ORACLE",
  VSPHERE = "VSPHERE",
  STANDARD = "STANDARD", // Physical
  HMC = "HMC",
  STORAGE = "STORAGE", // cm offline
  EXISTING = "EXISTING", // Templates are merged into new wizard. So this is essentially the template
}

export enum CMLiteTargetType {
  AZURE = "AZURE",
  ORACLE = "ORACLE",
  S3 = "S3",
  ESX = "ESX",
  STORAGE = "STORAGE",
}

export enum DiscoveryType {
  AGENT = "AGENT",
  AGENTLESS = "AGENTLESS",
}

export enum OperatingSystemFamily {
  SELECT = "SELECT",
  WINDOWS = "WINDOWS",
  LINUX = "LINUX",
  AIX = "AIX",
  SOLARIS = "SOLARIS",
  SUNOS = "SUNOS",
  UNKNOWN = "UNKNOWN",
  //used for webboot, this indicates a local boot
  LOCAL = "LOCAL",
}

export enum ArchitectureType {
  X86 = "X86",
  X64 = "X64",
  PPC = "PPC",
  PPC64LE = "PPC64LE",
}

export enum FirmwareType {
  BIOS = "BIOS",
  UEFI = "UEFI",
}

export enum BondingMode {
  ROUND_ROBIN = "ROUND_ROBIN",
  ACTIVE_BACKUP = "ACTIVE_BACKUP",
  DYNMAIC_LINK_AGGREGATION = "DYNMAIC_LINK_AGGREGATION",
}

export enum ControllerType {
  AUTO = "AUTO",
  LSI_LOGIC = "LSI_LOGIC",
  LSI_LOGIC_SAS = "LSI_LOGIC_SAS",
  PV_SCSI = "PV_SCSI",
}

export enum NetworkAdapterType {
  VMXNET3 = "VMXNET3",
  E1000 = "E1000",
}

export enum BackupClientType {
  FILE_BASED = "FILE_BASED",
  BLOCK_BASED = "BLOCK_BASED",
}

export enum ScriptType {
  PRE_BACKUP = "PRE_BACKUP",
  POST_BACKUP = "POST_BACKUP",
  PRE_REPLICATION = "PRE_REPLICATION",
  POST_REPLICATION = "POST_REPLICATION",
  POST_RECOVERY = "POST_RECOVERY",
  POST_SOFTWARE_INSTALL = "POST_SOFTWARE_INSTALL",
  PRE_OS_UPGRADE = "PRE_OS_UPGRADE",
  POST_OS_UPGRADE = "POST_OS_UPGRADE",
}

export enum PowerState {
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
}

export enum ScheduleType {
  CONTINUOUS = "CONTINUOUS",
  MINUTELY = "MINUTELY",
  HOURLY = "HOURLY",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  ONCE = "ONCE",
}

export enum BackupType {
  FULL = 0,
  INCREMENTAL = 1,
}

export enum LogLevel {
  OFF = 0,
  MINIMAL = 1,
  STANDARD = 2,
  VERBOSE = 3,
  DEBUG = 4,
}

export enum DeploymentStrategy {
  VCENTER = "VCENTER",
  DATACENTER = "DATACENTER",
  HOST = "HOST",
  CLUSTER = "CLUSTER",
}

export enum ValidationMethod {
  FULL = 1,
  PARTIAL = 2,
  NONE = 3,
}

export enum Protocol {
  SELECT = "select",
  TCP = "tcp",
  UDP = "udp",
  ALL = "all",
}

export enum Placeholder {
  SELECT = "SELECT",
  ALL = "ALL",
}

export enum AttachmentType {
  XLS = "XLS",
  PDF = "PDF",
  CSV = "CSV",
}

export enum RecoveryReportOptions {
  INCLUDE_NOT_DEFINED = 0,
  INCLUDE_SOURCE_DETAILS = 1,
  INCLUDE_TARGET_DETAILS = 2,
  INCLUDE_TRANSFER_DETAILS = 4,
  INCLUDE_RECOVERY_STATISTICS = 8,
  INCLUDE_SIMULATION_STATISTICS = 16,
  INCLUDE_REPLICATION_STATISTICS = 32,
  INCLUDE_COMPLETED = 64,
  INCLUDE_FAILED = 128,
  INCLUDED_LATEST_STATUS = 256,
}

export enum BackupReportOptions {
  INCLUDE_NOT_DEFINED = 0,
  INCLUDE_BACKUP_STATISTICS = 1,
  INCLUDE_BACKUP_COMPLETED = 2,
  INCLUDE_BACKUP_FAILED = 4,
}

export enum ReportType {
  BACKUP_ESTATE_LICENSING = "BACKUP_ESTATE_LICENSING",
  ORCHESTRATION = "ORCHESTRATION",
  USERS = "USERS",
  EVENT = "EVENT",
}

export enum OrchestrationFailureOption {
  PAUSE = "PAUSE",
  CONTINUE = "CONTINUE",
}

export enum DeviceType {
  SELECT = "SELECT",
  GENERIC = "generic",
  ETHERNET = "ethernet",
  VLAN = "vlan",
  VETH = "veth",
  BRIDGE = "bridge",
}

export enum AddressType {
  IPV4 = "ipv4",
  IPV6 = "ipv6",
}

export enum DomainType {
  AD = "AD",
  LDAP = "LDAP",
}

export enum UserType {
  LOCAL = "LOCAL",
  LDAP = "LDAP",
}

export enum NodeType {
  PRIMARY = 0,
  SECONDARY = 1,
}

export enum WidgetType {
  BACKUPCHART = "BACKUPCHART",
  BACKUPDATA = "BACKUPDATA",
  BACKUPFAILED = "BACKUPFAILED",
  BACKUPSERVERS = "BACKUPSERVERS",
  RECOVERCHART = "RECOVERCHART",
  RECOVERDATA = "RECOVERDATA",
  RECOVERFAILED = "RECOVERFAILED",
  SIMULATECHART = "SIMULATECHART",
  SIMULATEDATA = "SIMULATEDATA",
  SIMULATEFAILED = "SIMULATEFAILED",
  SIMULATEVIEW = "SIMULATEVIEW",
  REPLICATECHART = "REPLICATECHART",
  REPLICATEDATA = "REPLICATEDATA",
  REPLICATEFAILED = "REPLICATEFAILED",
  REPLICATEVIEW = "REPLICATEVIEW",
  ORCHESTRATECHART = "ORCHESTRATECHART",
  ORCHESTRATEDATA = "ORCHESTRATEDATA",
  ORCHESTRATEFAILED = "ORCHESTRATEFAILED",
  ESTATESUMMARY = "ESTATESUMMARY",
  FAILURECHART = "FAILURECHART",
  LICENSES = "LICENSES",
  EVENTS = "EVENTS",
  VAHEALTH = "VAHEALTH",
  REPORT = "REPORT",
  STORAGE = "STORAGE",
  RANSOMWAREMETRIC = "RANSOMWAREMETRIC",
}

export enum OperationStatus {
  OP_ERROR = "OP_ERROR",
  OP_IDLE = "OP_IDLE",
  OP_GETTING_CONFIG = "OP_GETTING_CONFIG",
  OP_BACKUP_LOCATION = "OP_BACKUP_LOCATION",
  OP_ACCESS_NETWORK = "OP_ACCESS_NETWORK",
  OP_ADVANCED_OPTIONS = "OP_ADVANCED_OPTIONS",
  OP_CHECK_CONFIG = "OP_CHECK_CONFIG",
  OP_CONFIGURE_RECOVERY = "OP_CONFIGURE_RECOVERY",
  OP_CONFIGURE_NETWORK = "OP_CONFIGURE_NETWORK",
  OP_CREATING_FILESYSTEMS = "OP_CREATING_FILESYSTEMS",
  OP_CREATING_STORAGEPOOLS = "OP_CREATING_STORAGEPOOLS",
  OP_STARTING_SPECIAL_PHASE = "OP_STARTING_SPECIAL_PHASE",
  OP_CREATING_VOLUMES = "OP_CREATING_VOLUMES",
  OP_RESTORING_FILES = "OP_RESTORING_FILES",
  OP_SYNCING_FILES = "OP_SYNCING_FILES",
  OP_REPLICATING_FILES = "OP_REPLICATING_FILES",
  OP_DISSIMILAR_HARDWARE = "OP_DISSIMILAR_HARDWARE",
  OP_MAKING_BOOTABLE = "OP_MAKING_BOOTABLE",
  OP_RECOVERY_SUCCESS = "OP_RECOVERY_SUCCESS",
  OP_SYNC_SUCCESS = "OP_SYNC_SUCCESS",
  OP_REPLICATION_SUCCESS = "OP_REPLICATION_SUCCESS",
  OP_RECOVERY_FAILURE = "OP_RECOVERY_FAILURE",
  OP_RECOVERY_ABORT = "OP_RECOVERY_ABORT",
  OP_SYNC_FAILURE = "OP_SYNC_FAILURE",
  OP_SYNC_ABORT = "OP_SYNC_ABORT",
  OP_REPLICATION_FAILURE = "OP_REPLICATION_FAILURE",
  OP_REPLICATION_ABORT = "OP_REPLICATION_ABORT",
}

export enum OperationStatusHumReadable {
  OP_ERROR = "Error",
  OP_IDLE = "Idle",
  OP_GETTING_CONFIG = "Obtaining source configuration",
  OP_BACKUP_LOCATION = "Accessing source data",
  OP_ACCESS_NETWORK = "Accessing the network",
  OP_ADVANCED_OPTIONS = "Validating advanced options",
  OP_CHECK_CONFIG = "Validating configuration",
  OP_CONFIGURE_RECOVERY = "Configuring the target environment",
  OP_CONFIGURE_NETWORK = "Configuring the network",
  OP_CREATING_FILESYSTEMS = "Configuring local disks",
  OP_STARTING_SPECIAL_PHASE = "Configuring local disks (special phase)",
  OP_CREATING_VOLUMES = "Configuring local volumes",
  OP_RESTORING_FILES = "Restoring backup",
  OP_SYNCING_FILES = "Syncing machine",
  OP_REPLICATING_FILES = "Replicating machine",
  OP_DISSIMILAR_HARDWARE = "Injecting new drivers",
  OP_MAKING_BOOTABLE = "Making the system bootable",
  OP_RECOVERY_SUCCESS = "Recovery successful",
  OP_SYNC_SUCCESS = "Sync successful",
  OP_REPLICATION_SUCCESS = "Replication successful",
  OP_RECOVERY_FAILURE = "Recovery failed",
  OP_RECOVERY_ABORT = "Aborted recovery operation",
  OP_SYNC_FAILURE = "Sync failed",
  OP_SYNC_ABORT = "Aborted sync operation",
  OP_REPLICATION_FAILURE = "Replication failed",
  OP_REPLICATION_ABORT = "Aborted replication operation",
}

export enum TokenType {
  CLONE = 0,
  SYNC = 1,
  TAILORING = 2,
  ASR = 6,
  XBMR_PHYSICAL = 8,
  XBMR_VIRTUAL = 9,
  XBMR_DESKTOP = 10,
}

export enum BusType {
  BUS_TYPE_UNKNOWN = "Unknown",
  BUS_TYPE_SCSI = "SCSI",
  BUS_TYPE_ATAPI = "ATAPI",
  BUS_TYPE_ATA = "ATA",
  BUS_TYPE_1394 = "IEEE 1394 (Firewire)",
  BUS_TYPE_SSA = "SSA",
  BUS_TYPE_FIBRE = "Fibre Channel",
  BUS_TYPE_USB = "USB",
  BUS_TYPE_RAID = "RAID",
  BUS_TYPE_ISCSI = "iSCSI",
  BUS_TYPE_SAS = "Serial Attached SCSI (SAS)",
  BUS_TYPE_SATA = "SATA",
  BUS_TYPE_SD = "Secure Digital (SD)",
  BUS_TYPE_MMMC = "Multimedia Card (MMC)",
  BUS_TYPE_RESERVEDMAX = "Reserved for System Use",
  BUS_TYPE_FILEBACKEDVIRTUAL = "File-Backed Virtual",
  BUS_TYPE_STORAGESPACES = "Storage Spaces",
  BUS_TYPE_NVME = "NVME",
  BUS_TYPE_MICROSOFTRESERVED = "Reserved",
}

export enum RequestType {
  PHYSICAL = "PHYSICAL",
  VIRTUAL = "VIRTUAL",
  DESKTOP = "DESKTOP",
  ACTIVATION = "ACTIVATION",
  CONTRACT = "CONTRACT",
  TOKEN = "TOKEN",
  UPGRADE = "UPGRADE",
  STAGING = "STAGING",
}

export enum LicenseReportType {
  CONTRACT = "CONTRACT",
  LICENSE = "LICENSE",
  PORTAL = "PORTAL",
}

export enum OffsiteRetentionPeriodIncrement {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export enum CommsType {
  SELECT = "Please Select",
  BACKUP = "Backup",
  PING = "Ping",
  RECOVER = "Recover",
  REPLICATE = "Replicate",
}

export enum DiskFormat {
  AUTO = "AUTO",
  VHD = "VHD",
  VHDX = "VHDX",
  VHDS = "VHDS",
}

export enum VaultAuthMethod {
  TOKEN = "TOKEN",
  LDAP = "LDAP",
  AD = "AD",
  USERPASS = "USERPASS",
}

export enum VaultCredentialType {
  KV_V1 = "KV_V1",
  KV_V2 = "KV_V2",
  LDAP = "LDAP",
  AD = "AD",
}

export enum CredentialType {
  DATABASE = "DATABASE",
  EXTERNAL = "EXTERNAL",
}

export enum EventTasks {
  CBMR_BACKUP = "CBMR Backup",
  VM_BACKUP = "VM Backup",
  RECOVERY = "Recovery", // Recover now
  SIMULATION = "Simulation",
  REPLICATION = "Replication",
  ABORTING_OPERATION = "Aborting Operation",
}

export enum RecoveryTargetType {
  EXISTING_PHYSICAL = "EXISTING_PHYSICAL",
  NEW_VM = "NEW_VM",
  EXISTING_LIVE_ENV = "EXISTING_LIVE_ENV",
  EXISTING_SANDBOX = "EXISTING_SANDBOX",
}
